import { render, staticRenderFns } from "./active-account-report.vue?vue&type=template&id=3be54825&"
import script from "./active-account-report.vue?vue&type=script&lang=js&"
export * from "./active-account-report.vue?vue&type=script&lang=js&"
import style0 from "./active-account-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports